<script setup lang="ts">
import "./MItemLabel.scss";
import { computed } from "vue";
import type { MItemLabelProps } from "./MItemLabel.props";
import { mItemLabelDefaults } from "./MItemLabel.props";

const props = withDefaults(defineProps<MItemLabelProps>(), mItemLabelDefaults);

const classes = computed(() => ["m-item-label", props.caption && "m-item-label--caption"]);
</script>

<template>
  <div :class="classes">
    <slot />
  </div>
</template>
